/**
 * The Mega Evolution mark, drawn the way Pokémon GO draws it (owner note
 * 2026-09-03: the two-strand helix looked nothing like the game's symbol):
 * a leaning lens, the twisted-ribbon silhouette of the helix, cut into
 * three diagonal bands. Filled in the current text colour so it sits in
 * the menu beside lucide icons and in a heading in the accent green. Same
 * props surface as a lucide icon (className, style) so it can stand in for
 * one.
 */
import { useId, type SVGProps } from "react";

/** The lens outline, leaning right, in a 24-unit box. */
const LENS = "M12 1.6 C 19.6 7.2, 19.6 16.8, 12 22.4 C 4.4 16.8, 4.4 7.2, 12 1.6 Z";

export function MegaIcon({
  className,
  style,
  size,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) {
  const clipId = useId();
  return (
    <svg
      {...rest}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      style={style}
      aria-hidden
      focusable="false"
    >
      <defs>
        <clipPath id={clipId}>
          <path d={LENS} transform="rotate(22 12 12)" />
        </clipPath>
      </defs>
      {/* Three bands rising to the right, clipped to the leaning lens: the
          ribbon's twists read as the gaps between them. */}
      <g clipPath={`url(#${clipId})`} transform="rotate(-32 12 12)">
        <rect x="-4" y="3.2" width="32" height="4.2" rx="1" />
        <rect x="-4" y="9.9" width="32" height="4.2" rx="1" />
        <rect x="-4" y="16.6" width="32" height="4.2" rx="1" />
      </g>
    </svg>
  );
}
